import React from 'react';
import { Typography, Box } from '@mui/material';

const ErrorScreen = ({ message }) => {
  return (
    <Box sx={{ textAlign: 'center', marginTop: '20%' }}>
      <Typography variant="h4" color="error">
        Error
      </Typography>
      <Typography variant="body1" color="error">
        {message}
      </Typography>
    </Box>
  );
};

export default ErrorScreen;